import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { login, isLoggedIn, updateSnackbar } from "../../actions";

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitForm = (email, password) => ev => {
      ev.preventDefault();
      this.props.login(email, password);
    };
  }

  componentDidUpdate(prevProps) {
    console.log(
      "[LOGIN] COMPONENTDIDUPDATE:",
      prevProps.auth.uid,
      this.props.auth.uid
    );
    if (
      this.props.auth !== prevProps.auth &&
      this.props.auth.uid !== "0" &&
      this.props.auth.uid !== "init"
    ) {
      // WHY IS IT GOING TO SECURITY QUESTION?
      //this.props.history.push("/security-question");
      console.log("[LOGIN] COMPONENTDIDUPDATE: Going to /");
      this.props.history.push("/");
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    console.log("[LOGIN] RENDER");
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{
          minHeight: "100vh",
          width: "100vw",
          overflow: "hidden",
          backgroundImage: "linear-gradient(-30deg, #3e0106 , #d0202f)"
        }}
      >
        <Card raised style={{ width: "60%", maxWidth: "1100px" }}>
          <CardContent style={{ padding: "0px" }}>
            <Grid container justify="center" alignItems="center">
              <Grid item xs={12} md={7} lg={8}>
                <div
                  style={{
                    background: `url(/loginbg.jpg) center`,
                    height: "500px",
                    width: "100%",
                    backgroundSize: "cover"
                  }}
                ></div>
              </Grid>
              <Grid item xs={12} sm={8} md={5} lg={4}>
                <div style={{ padding: "50px" }}>
                  <img
                    src="/logoStructube.png"
                    alt="logo"
                    style={{ width: "90%", margin: "0 auto", display: "block" }}
                  />

                  <form
                    onSubmit={this.submitForm(
                      this.state.email,
                      this.state.password
                    )}
                  >
                    <div>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        type="email"
                        label="Email"
                        name="email"
                        placeholder="Email"
                        value={this.state.email}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        type="password"
                        name="password"
                        label="Password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.handleChange}
                      />
                    </div>

                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="large"
                      disabled={this.props.inProgress}
                      style={{ boxShadow: "none", marginTop: "20px" }}
                    >
                      Sign in
                    </Button>
                  </form>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

Login.propTypes = {
  auth: PropTypes.object,
  inProgress: PropTypes.bool,
  history: PropTypes.object,
  login: PropTypes.func
};

export default connect(mapStateToProps, { login, isLoggedIn, updateSnackbar })(
  Login
);
